// extracted by mini-css-extract-plugin
module.exports = {"SectionU2":"SectionU21_SectionU2__unNE9"};